// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".gradient-x-overlay-sm-indigo:before{background-image:linear-gradient(45deg,transparent,rgba(4,214,214,.082));background-repeat:repeat-x}", ""]);
// Exports
module.exports = exports;
